export function getLabel(label, required) {
  return required ? `* ${label} (required)` : label;
}
